import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { FaFilePdf, FaFileCsv } from 'react-icons/fa6';
import { BiDetail } from 'react-icons/bi';
import "./punctuality.css"
import moment from "moment";
import { downloadApiCall } from '../../../service';
import config from '../../config';
import Success from '../../utils/Success';
import Error from '../../utils/Error';
import { urlHelper } from '../../utils/urlHelpers';

const OriginBasedTable = ({ displayedVehicles, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage }) => {

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [dataSuccessMessage, setDataSuccessMessage] = useState(false);
    const [dataErrorMessage, setDataErrorMessage] = useState(false);

    const handleSelectedRow = (data) => {
        localStorage.setItem('rowData', JSON.stringify(data));
        window.open('/live-tracking/moredetailreport');
    };

    const handleCSVDownload = async (data) => {
        const endpoint = urlHelper(config.apiEndpoints.punctualityReportOriginDetailedDownload.url, {
            jobId: data.jobId,
        });
        try {
            const payload = {
                host: config.apiEndpoints.punctualityReportOriginDetailedDownload.host,
                endPoint: endpoint,
                method: "POST",
            };
            const response = await downloadApiCall(payload)
            if (response.status === 400) {
                const errorData = await response.json();
                const errorMessage = errorData.message || "Something went wrong";
                setDataErrorMessage(true);
                console.log("responned error: ", await response)
                setErrorMessage(errorMessage);

                setTimeout(() => {
                    setErrorMessage('');
                    setDataErrorMessage(false);
                }, 1000);
                return;
            } else {
                const blob = await response.blob();
                const filename = `Punctuality Report_${data.serviceName}.csv`
                const link = document.createElement('a');
                const url = window.URL.createObjectURL(blob);
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                setDataSuccessMessage(true);
                setSuccessMessage("Successfully downloaded");

                setTimeout(() => {
                    setSuccessMessage('');
                    setDataSuccessMessage(false);
                }, 1000);
            }
        } catch (error) {
            console.log("error", error);
            setDataErrorMessage(true);
            setErrorMessage(error.data || "Something went wrong.");

            setTimeout(() => {
                setErrorMessage('');
                setDataErrorMessage(false);
            }, 1000);
        }
    }

    return (
        <div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell rowSpan={2}>S.No.</TableCell>
                            <TableCell rowSpan={2}>Service ID</TableCell>
                            <TableCell rowSpan={2}>Service Name</TableCell>
                            <TableCell rowSpan={2}>Vehicle No</TableCell>
                            {/* <TableCell rowSpan={2}>Origin City</TableCell>  */}
                            <TableCell colSpan={2} align="center">Origin</TableCell>
                            {/* <TableCell rowSpan={2}>Destination City</TableCell> */}
                            <TableCell colSpan={2} align="center">Destination</TableCell>
                            <TableCell rowSpan={2}>On-time Arrival Percentage</TableCell>
                            <TableCell rowSpan={2}>On-time Departure Percentage</TableCell>
                            <TableCell rowSpan={2}>Overall Punctuality Percentage</TableCell>
                            <TableCell rowSpan={2}>Action</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center">Enter</TableCell>
                            <TableCell align="center">Exit</TableCell>
                            <TableCell align="center">Enter</TableCell>
                            <TableCell align="center">Exit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedVehicles
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((data, index) => (
                                <TableRow key={data.jobId} >
                                    <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                                    <TableCell>{data.serviceID}</TableCell>
                                    <TableCell>{data.serviceName}</TableCell>
                                    <TableCell>{data.vehicleNo}</TableCell>
                                    {/* <TableCell>{data.originCityName !== "N/A" ? data.originCityName : "N/A"}</TableCell> */}
                                    <TableCell align="center">
                                        {data.originEnter === "N/A" ? "N/A" : moment.utc(data.originEnter).local().format('DD-MMM-YYYY h:mm A')}
                                    </TableCell>
                                    <TableCell align="center">
                                        {data.originExit === "N/A" ? "N/A" : moment.utc(data.originExit).local().format('DD-MMM-YYYY h:mm A')}
                                    </TableCell>
                                    {/* <TableCell>{data.destinationCityName !== "N/A" ? data.destinationCityName : "N/A"}</TableCell> */}
                                    <TableCell align="center">
                                        {data.destinationEnter === "N/A" ? "N/A" : moment.utc(data.destinationEnter).local().format('DD-MMM-YYYY h:mm A')}
                                    </TableCell>
                                    <TableCell align="center">
                                        {data.destinationExit === "N/A" ? "N/A" : moment.utc(data.destinationExit).local().format('DD-MMM-YYYY h:mm A')}
                                    </TableCell>
                                    <TableCell>{data.onTimeArrivalPercentage}</TableCell>
                                    <TableCell>{data.onTimeDeparturePercentage}</TableCell>
                                    <TableCell>{data.overAllPunctualityPercentage}</TableCell>
                                    <TableCell>
                                        <p style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '24px', cursor: 'pointer' }}>
                                            {/* <Tooltip title="PDF">
                                                <span>
                                                    <FaFilePdf />
                                                </span>
                                            </Tooltip> */}
                                            <Tooltip title="CSV">
                                                <span onClick={() => handleCSVDownload(data)}>
                                                    <FaFileCsv />
                                                </span>
                                            </Tooltip>
                                            <Tooltip title="Details">
                                                <span onClick={() => handleSelectedRow(data)}>
                                                    <BiDetail />
                                                </span>
                                            </Tooltip>
                                        </p>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={displayedVehicles.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[20, 30, 40, 50]}
                    labelRowsPerPage="Rows per page"
                />
            </TableContainer>
            <>
                {
                    dataSuccessMessage ? (
                        <div style={{ position: "fixed", bottom: "5%", right: "0%", width: "100%", zIndex: "969895" }}>
                            <Success msg={successMessage} />
                        </div>
                    ) : null
                }
                {
                    dataErrorMessage ? (
                        <div style={{ position: "fixed", bottom: "5%", right: "0%", width: "100%", zIndex: "969895" }}>
                            <Error msg={errorMessage} />
                        </div>
                    ) : null
                }
            </>
        </div>
    );
};

export default OriginBasedTable;
